import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "filter-section" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-md-3 col-sm-6 col-xm-12 col-sm-12" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-3 col-sm-6 col-xm-12 col-sm-12" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "col-md-3 col-xm-12 col-sm-12" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "d-flex gap-2" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_40 = { class: "dropdown" }
const _hoisted_41 = { class: "dropdown-menu" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  class: "modal fade",
  id: "delete-modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = { class: "modal-footer" }
const _hoisted_50 = { class: "modal-dialog modal-lg" }
const _hoisted_51 = { class: "modal-content" }
const _hoisted_52 = { class: "modal-header" }
const _hoisted_53 = { class: "modal-body" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-12 mb-3" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "form-check mb-2" }
const _hoisted_58 = ["id", "onUpdate:modelValue"]
const _hoisted_59 = ["for"]
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "d-flex gap-2 mb-2" }
const _hoisted_62 = { class: "text-muted" }
const _hoisted_63 = { class: "modal-footer" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.checkPermission('CreateRecensement'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
              to: "/fiche-recensement"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode(" Nouveau Recensement ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, {
          name: "total",
          modelValue: _ctx.leTotal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.leTotal) = $event)),
          "aria-disabled": "true",
          type: "text",
          disabled: "",
          class: "form-control text-center text-black shadow-none fs-md-15 text-black"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.valideEtape3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showExportModal())),
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("i", { class: "fas fa-file-excel position-relative ms-5 fs-12" }, null, -1),
              _createTextVNode(" Exporter Excel ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.valideEtape3)
          ? (_openBlock(), _createElementBlock("button", _hoisted_6, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("span", {
                class: "spinner-grow spinner-grow-sm me-2",
                role: "status",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" Génération... ", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "mb-3 text-primary" }, [
            _createElementVNode("i", { class: "fas fa-filter me-2" }),
            _createTextVNode("Filtres de recherche ")
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx.motCle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.motCle) = $event)),
                  name: "mot",
                  type: "text",
                  "aria-disabled": "true",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Nom, prénom, NPI..."
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "mot",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Agent ", -1)),
                _createVNode(_component_Field, {
                  name: "agent",
                  modelValue: _ctx.agent,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agent) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.agentOptions,
                      searchable: true,
                      noResultText: "Aucun enregistrement trouvé",
                      placeholder: "Sélectionner un agent"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "agent",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " État Usager ", -1)),
                _createVNode(_component_Field, {
                  name: "etatUsager",
                  modelValue: _ctx.etatUsager,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.etatUsager) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.etatUsagerOptions,
                      searchable: true,
                      noResultText: "Aucun état trouvé",
                      placeholder: "Sélectionner un état"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "etatUsager",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Secteur d'activité ", -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx.secteurActivite,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.secteurActivite) = $event)),
                  name: "secteurActivite",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Secteur d'activité"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secteurActivite",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date début ", -1)),
                _createVNode(_component_Field, {
                  name: "dateDebut",
                  type: "date",
                  modelValue: _ctx.dateDebut,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateDebut) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateDebut",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date fin ", -1)),
                _createVNode(_component_Field, {
                  name: "dateFin",
                  modelValue: _ctx.dateFin,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateFin) = $event)),
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateFin",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Type Marchand ", -1)),
                _createVNode(_component_Field, {
                  name: "typeMarchand",
                  modelValue: _ctx.typeMarchand,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.typeMarchand) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.typeMarchandOptions,
                      searchable: true,
                      noResultText: "Aucun type trouvé",
                      placeholder: "Sélectionner un type"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "typeMarchand",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Actions ", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
                    class: "btn btn-outline-secondary btn-sm btn-filter"
                  }, [...(_cache[28] || (_cache[28] = [
                    _createElementVNode("i", { class: "fas fa-undo me-1" }, null, -1),
                    _createTextVNode(" Réinitialiser ", -1)
                  ]))]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.searchWithFilters && _ctx.searchWithFilters(...args))),
                    class: "btn btn-primary btn-sm btn-filter"
                  }, [...(_cache[29] || (_cache[29] = [
                    _createElementVNode("i", { class: "fas fa-search me-1" }, null, -1),
                    _createTextVNode(" Rechercher ", -1)
                  ]))])
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[47] || (_cache[47] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("table", _hoisted_30, [
          _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " # "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Nom "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Prénom "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " NPI "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " État "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Emplacement "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Agent "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recensements, (recensement, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_31, _toDisplayString(recensement.id), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString(recensement.nom), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString(recensement.prenom), 1),
                _createElementVNode("td", _hoisted_34, _toDisplayString(recensement.npiUsager || 'N/A'), 1),
                _createElementVNode("td", _hoisted_35, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.getEtatBadgeClass(recensement.etatUsager)])
                  }, _toDisplayString(recensement.etatUsager), 3)
                ]),
                _createElementVNode("td", _hoisted_36, _toDisplayString(recensement.codeemp || 'N/A'), 1),
                _createElementVNode("td", _hoisted_37, _toDisplayString(recensement.nomPrenomAgent || 'N/A'), 1),
                _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.format_date(recensement.createdAt, 'DD/MM/YYYY')), 1),
                _createElementVNode("td", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", {
                      class: "badge text-white bg-secondary fs-15 dropdown-toggle",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createTextVNode(" Actions "),
                      _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_41, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.openNewWindow(recensement)),
                          type: "button",
                          class: "dropdown-item d-flex align-items-center"
                        }, [...(_cache[32] || (_cache[32] = [
                          _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Aperçu de la fiche ", -1)
                        ]))], 8, _hoisted_42)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.viewRecensement(recensement)),
                          type: "button",
                          class: "dropdown-item d-flex align-items-center"
                        }, [...(_cache[33] || (_cache[33] = [
                          _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Voir détails ", -1)
                        ]))], 8, _hoisted_43)
                      ]),
                      (_ctx.checkPermission('DeleteRecensement'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              "data-bs-target": "#delete-modal",
                              "data-bs-toggle": "modal",
                              onClick: ($event: any) => (_ctx.openDeleteModal(recensement.id)),
                              class: "dropdown-item d-flex align-items-center"
                            }, [...(_cache[34] || (_cache[34] = [
                              _createElementVNode("i", { class: "flaticon-trash lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Supprimer ", -1)
                            ]))], 8, _hoisted_45)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h6", { class: "modal-title" }, "Voulez-vous supprimer ce recensement ?"),
              _createElementVNode("button", {
                type: "button",
                id: "close-delete-modal",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "modal-body px-4" }, [
              _createElementVNode("p", null, "Cette action est irréversible.")
            ], -1)),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.deleteRecensement && _ctx.deleteRecensement(...args))),
                class: "btn btn-danger"
              }, "Supprimer"),
              _cache[37] || (_cache[37] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal"
              }, "Annuler", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "modal fade",
        id: "export-modal",
        tabindex: "-1",
        "aria-hidden": "true",
        onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeExportModal && _ctx.closeExportModal(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _cache[40] || (_cache[40] = _createElementVNode("h5", { class: "modal-title" }, [
                _createElementVNode("i", { class: "fas fa-file-excel me-2 text-success" }),
                _createTextVNode(" Options d'export Excel ")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeExportModal && _ctx.closeExportModal(...args))),
                "aria-label": "Close"
              })
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _cache[41] || (_cache[41] = _createElementVNode("h6", { class: "text-primary mb-3" }, [
                    _createElementVNode("i", { class: "fas fa-columns me-2" }),
                    _createTextVNode("Colonnes à inclure ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_56, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportColumns, (column, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-md-6",
                        key: key
                      }, [
                        _createElementVNode("div", _hoisted_57, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: 'col-' + key,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.exportColumns[key].selected) = $event)
                          }, null, 8, _hoisted_58), [
                            [_vModelCheckbox, _ctx.exportColumns[key].selected]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: 'col-' + key
                          }, _toDisplayString(column.label), 9, _hoisted_59)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.selectAllColumns && _ctx.selectAllColumns(...args))),
                      class: "btn btn-outline-primary btn-sm"
                    }, [...(_cache[42] || (_cache[42] = [
                      _createElementVNode("i", { class: "fas fa-check-square me-1" }, null, -1),
                      _createTextVNode(" Tout sélectionner ", -1)
                    ]))]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.deselectAllColumns && _ctx.deselectAllColumns(...args))),
                      class: "btn btn-outline-secondary btn-sm"
                    }, [...(_cache[43] || (_cache[43] = [
                      _createElementVNode("i", { class: "fas fa-square me-1" }, null, -1),
                      _createTextVNode(" Tout désélectionner ", -1)
                    ]))])
                  ]),
                  _createElementVNode("small", _hoisted_62, [
                    _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedColumnsCount) + " colonne(s) sélectionnée(s) ", 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeExportModal && _ctx.closeExportModal(...args)))
              }, [...(_cache[45] || (_cache[45] = [
                _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1),
                _createTextVNode(" Annuler ", -1)
              ]))]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.performExport && _ctx.performExport(...args))),
                class: "btn btn-success",
                disabled: _ctx.selectedColumnsCount === 0
              }, [
                _cache[46] || (_cache[46] = _createElementVNode("i", { class: "fas fa-download me-1" }, null, -1)),
                _createTextVNode(" Exporter (" + _toDisplayString(_ctx.selectedColumnsCount) + " colonnes) ", 1)
              ], 8, _hoisted_64)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_65, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}